import React from 'react'
import PropTypes from 'prop-types'
import Scrollspy from 'react-scrollspy'
import { Link } from 'react-scroll'

import Sticky from 'Pods/Shared/Sticky'

function HeaderNav({ sections, offset, additionalOffset }) {
  return (
    <Sticky
      className="enterprise-header-nav"
      position="top"
      stickyOffset={-offset}
      offset={-offset}
      selfAdjustingWidth
    >
      <div className="container-fixed">
        <div className="row">
          <div className="col-12">
            <Scrollspy
              className="nav-tabs nav-tabs--small nav-tabs--navigation-menu nav-tabs--bigger-navigation-menu"
              items={sections.map(section => section.id)}
              currentClassName="is-active"
              offset={offset - additionalOffset - 10}
            >
              {sections.map((section) => (
                <li key={section.id}>
                  <Link
                    className="navigation-menu__link"
                    activeClass="is-active"
                    to={section.id}
                    offset={offset - additionalOffset}
                    duration={500}
                    spy
                    smooth
                  >
                    {section.title}
                  </Link>
                </li>
              ))}
              <span className="btn-tab-container">
                <li className="btn-tab">
                  <Link
                    className="navigation-menu__link"
                    to="about-contact-section"
                    offset={offset - additionalOffset}
                    smooth
                  >
                    <button className="btn btn-primary">Contacts</button>
                  </Link>
                </li>
              </span>
            </Scrollspy>
          </div>
        </div>
      </div>
    </Sticky>
  )
}

HeaderNav.propTypes = {
  sections: PropTypes.array.isRequired,
  offset: PropTypes.number.isRequired,
  additionalOffset: PropTypes.number.isRequired,
}

export default HeaderNav
